export class LicenseError extends Error {
    constructor(code, message) {
        super();
        /**
         * Status code for http-related license errors.
         */
        this.status = -1;
        /**
         * Object for storing properties of an event that's useful for debugging.
         */
        this.debug = {};
        /**
         * Indicates whether we can play the next track.
         */
        this.canPlayNext = true;
        /**
         * Indicates whether is it recoverable.
         */
        this.unrecoverable = false;
        this.name = 'LicenseError';
        this.code = code;
        this.message = message;
    }
    static fatal(code, message) {
        const error = new LicenseError(code, message);
        error.unrecoverable = true;
        error.canPlayNext = false;
        return error;
    }
}
//# sourceMappingURL=license.js.map